import { render, staticRenderFns } from "./Eliminar_Fichero_Mercado.vue?vue&type=template&id=10183a00&scoped=true"
import script from "./Eliminar_Fichero_Mercado.vue?vue&type=script&lang=js"
export * from "./Eliminar_Fichero_Mercado.vue?vue&type=script&lang=js"
import style0 from "./Eliminar_Fichero_Mercado.vue?vue&type=style&index=0&id=10183a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10183a00",
  null
  
)

export default component.exports